import { createContext } from 'react';

export interface Selection {
  selecting: boolean;
  isSelected: (id: string) => boolean;
  toggle: (id: string) => void;
}

export const SelectionContext = createContext<Selection | null>(null);
